import { AlertService } from '../../services/alert.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Role } from '../../../identite/shared/classes/role';
import { IdentiteService } from '../../../identite/shared/services/identite.service';
import { TRANSLATE } from '../../classes/translatable';

@Component({
    selector: 'app-identite-quick-new',
    templateUrl: './identite-quick-new.component.html',
    styleUrls: ['./identite-quick-new.component.css']
})
export class IdentiteQuickNewComponent implements OnInit {

    @Input() role: Role;
    @Input() acl_roles?: string;
    @Output() roleChange = new EventEmitter();
    @Output() createdCallback = new EventEmitter<Role>();
    @Output() cancelCallback = new EventEmitter();

    constructor(
        private identiteService: IdentiteService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
    }


    insertIdentite() {
        this.identiteService.insertIdentite(this.role)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Identité créée avec succès'));
                this.role.id = retour.data;
                this.role.identite.computed_name = this.role.identite.nom + (this.role.identite.prenom ? ' ' + this.role.identite.prenom : '');
                this.emit();
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }


    emit() {
        this.createdCallback.emit(this.role);
    }

    emitCancelCallback() {
        this.cancelCallback.emit(this.role);
    }

}
